export default "__VITE_ASSET__494acbc6__"